import { bl_fi_sales_commission_pricing_model_line_RowClass } from '../../dbschema/bl_fi_sales_commission_pricing_model_line.model';
import { BaseContainerModel } from '../base-container.model';

export class SalesCommissionPricingModelLineContainerModel extends BaseContainerModel {
    bl_fi_sale_commission_pricing_model_line: bl_fi_sales_commission_pricing_model_line_RowClass = new bl_fi_sales_commission_pricing_model_line_RowClass();
}
